import type { Ref } from 'vue'

export function useObserveHeight() {
  const element: Ref<HTMLElement | undefined> = ref()
  const contentHeight = ref(0)

  const obs = new ResizeObserver(([infoBox]) => {
    contentHeight.value = infoBox.target.getBoundingClientRect().height
  })

  watch(
    element,
    el => {
      if (el) {
        contentHeight.value = el.getBoundingClientRect().height
        obs.observe(el)
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    obs.disconnect()
  })

  return { element, contentHeight }
}
